const frontProjects = [
  {
    id: crypto.randomUUID(),
    name: 'pizza-shop',
    type: 'frontend',
    img: '/thumbnail/pizza-shop.png',
    description: 'Pizza Shop é uma plataforma de gerenciamento de pedidos. Permite login, cadastro de estabelecimentos, visualização de métricas como receita e pedidos, e atualização do status de pedidos. Inclui gráficos de produtos populares e receita diária.',
    development:
    <>
        <p>Pizza Shop é uma plataforma de gerenciamento de pedidos. A página inicial é uma área de login onde o usuário deve inserir seu email cadastrado. Caso não possua uma conta, é possível cadastrar um novo estabelecimento preenchendo um formulário com algumas informações. Após um login bem-sucedido, o usuário é direcionado para a tela "Dashboard", onde tem acesso a várias métricas importantes, como receita total, pedidos e cancelamentos no mês e pedidos do dia. A tela também inclui gráficos de produtos populares e da receita diária para um período específico determinado pelo usuário. Na tela de "Pedidos", são exibidas informações detalhadas sobre todos os pedidos, permitindo atualizar o status de cada um, como: pendente, em preparo, em entrega, entregue e cancelado. O usuário pode filtrar pedidos específicos pelo ID, nome do cliente ou status.</p>
        <br/>
        <p>A aplicação foi desenvolvida com Vite (versão 5.2.0), React (versão 18.2.0) e TypeScript. O back-end foi desenvolvido e disponibilizado pela equipe da Rocketseat. A estilização do projeto foi realizada com Tailwind CSS e componentes das bibliotecas Shadcn UI e Recharts para os gráficos. Outras bibliotecas e ferramentas utilizadas incluem: Zod e React Hook Form para validações e formulários, Sonner para notificações toast, Date-fns, Axios, Lucide React, ESLint e Git para controle de versão.</p>
        <br/>
        <p><strong>➜ Por questões visuais, o banco de dados é resetado a cada login, garantindo que os pedidos estejam sempre com datas atualizadas e que as métricas sejam visualizadas nos gráficos desde o primeiro momento.</strong></p>
        <br/>
        <p><strong>➜ A responsividade deste projeto está em desenvolvimento.</strong></p>
    </>,
    links: {
      app: 'https://app-pizza-shop.vercel.app',
      repo: 'https://github.com/h3zord/pizza-shop',
    },
    skills: {
      name: [
        'Vite',
        'React',
        'Typescript',
        'Tailwind CSS',
        'Git'
      ],
      icon: [
        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vitejs/vitejs-original.svg" className="skill-icon" alt="Vite logo"/>,
        <i className="devicon-react-original colored skill-icon" />,
        <i className="devicon-typescript-plain colored skill-icon" />,
        <i className="devicon-tailwindcss-original colored skill-icon" />,
        <i className="devicon-git-plain colored skill-icon" />
      ],
    },
    demonstration: {
      video: '/videos/pizza-shop.mp4',
      screenshots: [
        '/screenshots/pizza-shop/pizza-shop-screen-01.png',
        '/screenshots/pizza-shop/pizza-shop-screen-02.png',
        '/screenshots/pizza-shop/pizza-shop-screen-03.png',
        '/screenshots/pizza-shop/pizza-shop-screen-04.png',
        '/screenshots/pizza-shop/pizza-shop-screen-05.png',
        '/screenshots/pizza-shop/pizza-shop-screen-06.png',
        '/screenshots/pizza-shop/pizza-shop-screen-07.png',
        '/screenshots/pizza-shop/pizza-shop-screen-08.png',
        '/screenshots/pizza-shop/pizza-shop-screen-09.png',
        '/screenshots/pizza-shop/pizza-shop-screen-10.png',
        '/screenshots/pizza-shop/pizza-shop-screen-11.png',
        '/screenshots/pizza-shop/pizza-shop-screen-12.png',
        '/screenshots/pizza-shop/pizza-shop-screen-13.png',
        '/screenshots/pizza-shop/pizza-shop-screen-14.png',
      ]
    },
  },
  {
    id: crypto.randomUUID(),
    name: 'book-wize',
    type: 'frontend',
    img: '/thumbnail/book-wize.png',
    description: 'Book Wize é uma plataforma de recomendação de livros. Permite login, visualização de últimas leituras, avaliações recentes, livros populares, e filtração por nome do livro, autor ou categoria. Usuários logados podem avaliar e comentar livros.',
    development: 
    <>
      <p>Book Wize é uma plataforma de recomendação de livros para leitores. A aplicação começa com uma página de login, onde o usuário pode entrar com sua conta do Google, GitHub ou como visitante. Após o login, o usuário é direcionado para a página de "Início", que exibe informações como sua última leitura, avaliações mais recentes e livros populares. Na seção "Explorar", o usuário pode visualizar uma lista de todos os livros, filtrando por nome do livro, autor ou categoria. Ao clicar no card de um livro, são exibidas mais informações, como número de avaliações, número de páginas, categorias, comentários e uma nota avaliativa. Usuários logados podem deixar comentários, atribuir notas e marcar o livro como "lido". Na seção "Perfil", o usuário encontra informações específicas sobre seus últimos livros avaliados, número de páginas lidas, autores lidos, livros avaliados e a categoria mais lida.</p>
      <br/>
      <p>A aplicação foi desenvolvida com Next.js (versão 14.1.3), React (versão 18) e TypeScript. As requisições foram construídas utilizando Route Handlers do próprio Next.js. O banco de dados escolhido foi PostgreSQL, em conjunto com Prisma ORM para abstração das queries. O NextAuth.js foi usado para a configuração do login social. A estilização foi feita com Styled Components. Outras bibliotecas utilizadas incluem: ESLint, React Hook Form, Date FNS, Framer Motion, Phosphor Icons, Material UI, Radix UI e Git para controle de versão.</p>
      <br/>
      <p><strong>➜ A responsividade deste projeto está em desenvolvimento.</strong></p>
    </>,
    challenges: '',
    links: {
      app: 'https://book-wize.vercel.app/',
      repo: 'https://github.com/h3zord/book-wize',
    },
    skills: {
      name: [
        'Next.js',
        'React',
        'Typescript',
        'PostgreSQL',
        'Prisma ORM',
        'NextAuth.js',
        'Styled Components',
        'Git'
      ],
      icon: [
        <i className="devicon-nextjs-plain skill-icon" style={{ color: 'white' }} />,
        <i className="devicon-react-original colored skill-icon" />,
        <i className="devicon-typescript-plain colored skill-icon" />,
        <i class="devicon-postgresql-plain colored skill-icon" />,
        <i className="devicon-prisma-original skill-icon" style={{ color: 'white' }} />,
        <img src="/tools/nextauth.png" className="skill-icon" alt="NextAuth logo"/>,
        <img src="/tools/styled-components.png" className="skill-icon" alt="Styled-components logo"/>,
        <i className="devicon-git-plain colored skill-icon" />
      ],
    },
    demonstration: {
      video: '/videos/book-wize.mp4',
      screenshots: [
        '/screenshots/book-wize/book-wize-screen-01.png',
        '/screenshots/book-wize/book-wize-screen-02.png',
        '/screenshots/book-wize/book-wize-screen-03.png',
        '/screenshots/book-wize/book-wize-screen-04.png',
        '/screenshots/book-wize/book-wize-screen-05.png',
        '/screenshots/book-wize/book-wize-screen-06.png',
      ]
    },
  },
  {
    id: crypto.randomUUID(),
    name: 'ignite-call',
    type: 'frontend',
    img: '/thumbnail/ignite-call.png',
    description: 'Ignite Call é uma plataforma de agendamentos. Permite cadastro, conexão ao Google Calendar, definição de disponibilidade, e visualização de um calendário com horários disponíveis. Facilita a criação e gerenciamento de agendamentos com detalhes do usuário.',
    development:
      <>
        <p>Ignite Call é uma plataforma de agendamentos. Na página principal, o usuário inicia inserindo seu nome de usuário para efetuar um pré-cadastro. Em seguida, é redirecionado para a página de cadastro, onde é necessário preencher o nome completo, com a opção de editar o nome de usuário preenchido anteriormente. Depois, o usuário precisa conectar sua conta do Google para que a aplicação tenha acesso ao Google Calendar e possa efetuar os agendamentos. Na próxima etapa do registro, o usuário deve selecionar o intervalo de horários em que estará disponível, assim como os dias da semana, sendo que cada agendamento exigirá 1 hora da sua disponibilidade. A última etapa do registro consiste em adicionar uma descrição ao perfil. Ao concluir todo o processo de registro, o usuário é direcionado para a página de agendamento, onde um calendário exibe os dias e horários de acordo com a disponibilidade configurada pelo usuário na etapa de registro. Após selecionar a data e o horário, ocorre a última etapa do agendamento, onde é necessário preencher o nome completo, email e observações, se julgar necessário.</p>
        <br/>
        <p>A projeto foi desenvolvida com Next.js (versão 14.0.3), React (versão 18) e TypeScript. As requisições foram construídas utilizando Route Handlers do próprio Next.js. O banco de dados usado foi PostgreSQL, em conjunto com Prisma ORM para abstração das queries. A maioria dos componentes foi fornecida pelo design system Ignite UI, que usa a biblioteca Stitches para estilização. Para validação dos formulários, foi utilizada a biblioteca Zod em conjunto com React Hook Form. A ferramenta NextAuth.js foi usada para login social, neste caso, o Google. Outras bibliotecas utilizadas incluem: ESLint, Phosphor Icons, Next SEO, Day.js, Axios, TanStack Query para lidar com as requisições e Git para controle de versão.</p>
        <br/>
        <p><strong>➜ O fuso horário está configurado para a região América/São Paulo.</strong></p>
        <br/>
        <p><strong>➜ A responsividade deste projeto está em desenvolvimento.</strong></p>
      </>,
    challenges: '',
    links: {
      app: 'https://app-ignite-call.vercel.app',
      repo: 'https://github.com/h3zord/ignite-call',
    },
    skills: {
      name: [
       'Next.js',
       'React',
       'Typescript',
       'PostgreSQL',
       'Prisma ORM',
       'NextAuth.js',
       'TanStack Query',
       'Git',
      ],
      icon: [
        <i className="devicon-nextjs-plain skill-icon" style={{ color: 'white' }} />,
        <i className="devicon-react-original colored skill-icon" />,
        <i className="devicon-typescript-plain colored skill-icon" />,
        <i class="devicon-postgresql-plain colored skill-icon" />,
        <i className="devicon-prisma-original skill-icon" style={{ color: 'white' }} />,
        <img src="/tools/nextauth.png" className="skill-icon" alt="NextAuth logo"/>,
        <img src="/tools/tanstack-query.png" className="skill-icon" alt="TanStack Query logo"/>,
        <i className="devicon-git-plain colored skill-icon" />
      ],
    },
    demonstration: {
      video: '/videos/ignite-call.mp4',
      screenshots: [
        '/screenshots/ignite-call/ignite-call-screen-01.png',
        '/screenshots/ignite-call/ignite-call-screen-02.png',
        '/screenshots/ignite-call/ignite-call-screen-03.png',
        '/screenshots/ignite-call/ignite-call-screen-04.png',
        '/screenshots/ignite-call/ignite-call-screen-05.png',
        '/screenshots/ignite-call/ignite-call-screen-06.png',
        '/screenshots/ignite-call/ignite-call-screen-07.png',
        '/screenshots/ignite-call/ignite-call-screen-08.png',
      ]
    },
  },
  {
    id: crypto.randomUUID(),
    name: 'ignite-ui',
    type: 'frontend',
    img: '/thumbnail/ignite-ui.png',
    description: 'Ignite UI é um design system usado na aplicação Ignite Call. Fornece um conjunto de padrões, componentes e diretrizes para criar uma experiência de usuário consistente. Inclui paleta de cores, tipografias, espaçamentos, botões e formulários reutilizáveis.',
    development: 
      <>
        <p>Ignite UI é um design system utilizado na aplicação Ignite Call. De forma resumida, um design system é um conjunto de padrões, componentes e diretrizes que ajudam a criar uma experiência de usuário consistente e eficiente em todas as partes de um produto digital. A principal vantagem de um design system é garantir uniformidade e reusabilidade, facilitando a colaboração entre designers e desenvolvedores. O Ignite UI conta com elementos como paleta de cores, tipografias, espaçamento, botões, formulários e outros componentes de interface.</p>
        <br/>
        <p>Esta aplicação é um monorepo que contém os seguintes pacotes:</p>
        <br/>
        <p>● docs: Documentação de todos os elementos utilizando Vite (versão 4.4.5), Storybook (versão 7.5.1), TypeScript e Polished.</p>
        <br/>
        <p>● react: Onde os componentes foram construídos com React (versão 18.2.0), TypeScript e estilizados com a biblioteca Stitches.</p>
        <br/>
        <p>● tokens: Descrição de todas as cores, fontes, pesos e tamanhos de fontes, espaçamentos e raios de borda.</p>
        <br/>
        <p>● ts-config e eslint-config: Configurações do TypeScript e ESLint, respectivamente, utilizadas nos pacotes descritos anteriormente.</p>
      </>,
    challenges: '',
    links: {
      app: 'https://ignite-ui.vercel.app/',
      repo: 'https://github.com/h3zord/ignite-ui',
    },
    skills: {
      name: [
       'Vite',
       'StoryBook',
       'React',
       'Typescript',
       'Stitches',
       'Turborepo',
       'Git'
      ],
      icon: [
        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vitejs/vitejs-original.svg" className="skill-icon" alt="Vite logo"/>,
        <i class="devicon-storybook-plain colored skill-icon" />,
        <i className="devicon-react-original colored skill-icon" />,
        <i className="devicon-typescript-plain colored skill-icon" />,
        <img src="/tools/stitches.svg" className="skill-icon" alt="Stitches logo"/>,
        <img src="/tools/turborepo.png" className="skill-icon" alt="Turborepo logo"/>,
        <i className="devicon-git-plain colored skill-icon" />
      ],
    },
    demonstration: {
      video: '/videos/ignite-ui.mp4',
      screenshots: [
       '/screenshots/ignite-ui/ignite-ui-screen-01.png',
       '/screenshots/ignite-ui/ignite-ui-screen-02.png',
       '/screenshots/ignite-ui/ignite-ui-screen-03.png',
       '/screenshots/ignite-ui/ignite-ui-screen-04.png',
       '/screenshots/ignite-ui/ignite-ui-screen-05.png',
       '/screenshots/ignite-ui/ignite-ui-screen-06.png',
       '/screenshots/ignite-ui/ignite-ui-screen-07.png',
      ]
    },
  },
  {
    id: crypto.randomUUID(),
    name: 'coffee-delivery',
    type: 'frontend',
    img: '/thumbnail/coffee-delivery.png',
    description: 'Coffee Delivery é uma aplicação de comercialização de cafés. Permite aos usuários visualizar produtos, adicionar itens ao carrinho, preencher dados de entrega e realizar pagamentos. Inclui páginas de checkout e sucesso com informações detalhadas sobre a entrega.',
    development:
      <>
        <p>Coffee Delivery é uma aplicação que simula a comercialização de cafés. A página principal exibe todos os cafés disponíveis para compra. Na página de checkout, o cliente preenche seus dados, como CEP, cidade, endereço residencial e forma de pagamento. A aplicação permite adicionar, remover e excluir itens do carrinho. Após a finalização da compra, o usuário é direcionado para uma página de sucesso, que mostra as informações sobre a entrega do produto.</p>
        <br/>
        <p>A aplicação foi desenvolvida com Vite (versão 4.4.5), React (versão 18.2.0) e TypeScript. Foi utilizado React Hook Form para lidar com o formulário e Zod para validar as informações. A estilização foi realizada com Styled Components. Outras bibliotecas utilizadas incluem: ESLint, Framer Motion, Immer, React Toastify, Phosphor Icons e Git para controle de versão. Foram realizados testes E2E com a biblioteca Cypress, verificando a presença de elementos na tela e o comportamento correto da aplicação conforme a interação do usuário. Todos os testes estão na pasta cypress/e2e.</p>
        <br/>
        <p><strong>➜ A responsividade deste projeto está em desenvolvimento.</strong></p>
      </>,
    challenges: '',
    links: {
      app: 'https://app-coffee-delivery.vercel.app',
      repo: 'https://github.com/h3zord/coffee-delivery',
    },
    skills: {
      name: [
        'Vite',
        'React',
        'Typescript',
        'Styled Components',
        'Cypress',
        'Git'
      ],
      icon: [
        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vitejs/vitejs-original.svg" className="skill-icon" alt="Vite logo"/>,
        <i className="devicon-react-original colored skill-icon" />,
        <i className="devicon-typescript-plain colored skill-icon" />,
        <img src="/tools/styled-components.png" className="skill-icon" alt="Styled-components logo"/>,
        <i className="devicon-cypressio-plain skill-icon" style={{color: 'white'}}/>,
        <i className="devicon-git-plain colored skill-icon" />
      ],
    },
    demonstration: {
      video: '/videos/coffee-delivery.mp4',
      screenshots: [
        '/screenshots/coffee-delivery/coffee-delivery-screen-01.png',
        '/screenshots/coffee-delivery/coffee-delivery-screen-02.png',
        '/screenshots/coffee-delivery/coffee-delivery-screen-03.png',
        '/screenshots/coffee-delivery/coffee-delivery-screen-04.png',
      ]
    },
  },
  {
    id: crypto.randomUUID(),
    name: 'dt-money',
    type: 'frontend',
    img: '/thumbnail/dt-money.png',
    description: 'DT Money é uma aplicação de controle de gastos. Permite visualizar entradas, saídas e saldo total. Usuários podem adicionar, excluir e filtrar transações, que são exibidas em uma tabela com descrição, valor, categoria e data.',
    development:
      <>
       <p>DT Money é uma aplicação para controle de gastos. A página principal apresenta três cards: entradas, saídas e saldo total. Todas as transações são exibidas em uma tabela, contendo descrição, valor, categoria e data do registro. O usuário pode manipular as transações, filtrando por descrição, excluindo ou adicionando novas transações ao preencher as informações no formulário.</p>
       <br/>
       <p>O projeto foi desenvolvido utilizando Vite (versão 5.3.4) e React (versão 18.3.1) em conjunto com TypeScript. Todas as transações cadastradas estão armazenadas no localstorage do navegador. A estilização foi feita com a biblioteca Styled Components. Outras bibliotecas e ferramentas utilizadas incluem: React Hook Form e Zod para lidar com formulários e validações, Radix UI, Framer Motion, Phosphor Icons, ESLint e Git para controle de versão.</p>
       <br/>
       <p><strong>➜ Por questões visuais, a tabela de gastos já vem pré-preenchida caso não exista nenhuma transação cadastrada.</strong></p>
       <br/>
       <p><strong>➜ A responsividade deste projeto está em desenvolvimento.</strong></p>
      </>,
    challenges: '',
    links: {
      app: 'https://app-dt-money.vercel.app',
      repo: 'https://github.com/h3zord/dt-money',
    },
    skills: {
      name: [
        'Vite',
        'React',
        'Typescript',
        'Styled Components',
        'Git'
      ],
      icon: [
        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vitejs/vitejs-original.svg" className="skill-icon" alt="Vite logo"/>,
        <i className="devicon-react-original colored skill-icon" />,
        <i className="devicon-typescript-plain colored skill-icon" />,
        <img src="/tools/styled-components.png" className="skill-icon" alt="Styled-components logo"/>,
        <i className="devicon-git-plain colored skill-icon" />
      ],
    },
    demonstration: {
      video: '/videos/dt-money.mp4',
      screenshots: [
        '/screenshots/dt-money/dt-money-screen-01.png',
        '/screenshots/dt-money/dt-money-screen-02.png',
      ]
    },
  },
]

export default frontProjects;
